<template>
    <Modal v-model="modal"
           :title="$t((isCreate?'创建':'编辑')+'权限')"
           :mask-closable="false"
           @on-cancel="cancel">
        <Form ref="form"
              :model="formData"
              :rules="rules"
              :label-width="120">
            <FormItem :label="$t('权限标识')+'：'"
                      prop="policyName">
                <Input style="width: 80%"
                       :placeholder="$t('权限标识')"
                       :maxlength="32"
                       v-model="formData.policyName" />
            </FormItem>
            <FormItem :label="$t('显示名称')+'：'">
                <Input style="width: 80%"
                       :placeholder="$t('显示名称')"
                       :maxlength="32"
                       v-model="formData.displayName" />
            </FormItem>
            <FormItem :label="$t('权限配置')+'：'"
                      v-if="isCreate">
                <div class="authority">
                    <Tree style="margin-left:10px"
                          v-show="authorityData.length > 0"
                          :data="authorityData"
                          :render="renderContent"
                          @on-check-change="checkChange"
                          show-checkbox></Tree>
                </div>
            </FormItem>
            <FormItem :label="$t('描述')+'：'">
                <Input v-model="formData.description"
                       type="textarea"
                       style="width: 80%;"
                       :autosize=" { minRows: 4, maxRows: 8 }"
                       :maxlength="225"
                       :placeholder="$t('描述')"
                       class="slbist-item" />
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    @click="submit">{{loading ? $t('提交中'):$t('保存')}}</Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api'
export default {
    name: 'strategy',
    data () {
        return {
            checkedAll: [],
            modal: false,
            loading: false,
            isCreate: true,
            formData: {
                policySid: '',
                policyName: '',
                displayName: '',
                description: ''

            },
            checkedTree: [],
            authorityData: [],
            authorityDataBack: [],
            rules: {
                policyName: [
                    { required: true, message: this.$t('该字段不能为空'), trigger: 'change' },
                    {
                        trigger: 'blur',
                        validator: async (rule, value, callback) => {
                            // 唯一性验证
                            if (this.isCreate) {
                                const result = await this.uniqueName(value)
                                if (!result) {
                                    return callback(new Error(this.$i18n.t('权限标识不能重复')))
                                } else {
                                    return callback()
                                }
                            }
                        }
                    }]
            }
        }
    },
    watch: {
        checkedTree (newval, oldval) {
            if ((oldval.length > 0 && oldval[0].title === '全部') || (newval.length > 0 && newval[0].title === '全部')) {
                this.checkedFun()
            }
        }
    },
    methods: {

        renderContent (h, { root, node, data }) {
            return h('span', {
                style: {
                    display: 'inline-block',
                    width: '100%'
                }
            }, [
                h('span', [
                    h('span', data.title)
                ]),
                h('Tooltip', {
                    props: { transfer: true, placement: 'right', theme: 'light' },
                    style: { display: data.data && ['CreateService', 'DeleteService', 'RenewService', 'EditSevice', 'ApplyModelArts', 'releaseModelArts', 'ReleaseShare'].includes(data.data.opCode) ? 'inherit' : 'none' }
                }, [h('i', {
                    class: {
                        'icon-prompt-1-o': true,
                        'tips-style': true
                    },
                    style: {
                        'font-size': '12px',
                        'padding-right': '5px',
                        'margin-left': '5px'
                    }
                }),
                h('div', { slot: 'content' }, [
                    h('p', this.$t('由于特殊作业限制，子用户即使赋予此权限，也不能进行相关操作。'))])]
                )
            ])
        },
        async uniqueName (name) {
            const data = await this.axios.get(this.urlFormat(API.GET_ACCESS_POLICES_CHECK_NAME + '?name=' + name, false))
            return !data
        },
        openModal (data) {
            this.formData = {
                policySid: '',
                policyName: '',
                displayName: '',
                description: ''
            }
            this.isCreate = true
            this.init()
            if (data) {
                this.isCreate = false
                this.formData.policySid = data.policySid
                this.formData.policyName = data.policyName || ''
                this.formData.displayName = data.displayName || ''
                this.formData.description = data.description || ''
            }
            this.modal = true
        },
        init () {
            this.checkedAll = []
            this.checkedTree = []
            this.authorityData = []
            this.loading = true
            this.axios.get(this.urlFormat(API.GET_ACCESS_POLICES_ASSERTIONS, false), {
                params: {}
            }).then(res => {
                this.loading = false
                if (res.length > 0) {
                    for (let i = 0; i < res.length; i++) {
                        const assertionTypes = []
                        for (let j = 0; j < res[i].assertionTypes.length; j++) {
                            const assertions = []
                            for (let y = 0; y < res[i].assertionTypes[j].assertions.length; y++) {
                                assertions.push(
                                    {
                                        data: res[i].assertionTypes[j].assertions[y],
                                        id: res[i].assertionTypes[j].assertions[y].assertionSid,
                                        title: res[i].assertionTypes[j].assertions[y].opName,
                                        expand: false,
                                        disabled: false,
                                        checked: false,
                                        index: 3,
                                        children: []
                                    }
                                )
                            }
                            assertionTypes.push(
                                {
                                    id: res[i].assertionTypes[j].assertionType,
                                    title: res[i].assertionTypes[j].assertionTypeName,
                                    expand: false,
                                    disabled: false,
                                    checked: false,
                                    children: assertions
                                }
                            )
                        }
                        this.authorityData.push({
                            expand: false,
                            id: res[i].nodeKey,
                            disabled: false,
                            title: this.$t(res[i].serviceName),
                            children: assertionTypes
                        })
                    }
                }
                this.authorityDataBack = this.deepClone(this.authorityData)
            }).catch(e => {
                this.loading = false
            })
        },
        deepClone (obj) {
            const _obj = JSON.stringify(obj)
            const objClone = JSON.parse(_obj)
            return objClone
        },
        checkedFun () {
            if ((this.checkedTree.length > 0) && (this.checkedTree[0].title === '全部' || this.authorityData[0].title === 'All')) {
                for (let i = 0; i < this.authorityData.length; i++) {
                    if (this.authorityData[i].title !== '全部' && this.authorityData[i].title !== 'All') {
                        this.authorityData[i].disabled = true
                        for (const j in this.authorityData[i].children) {
                            this.authorityData[i].children[j].disabled = true
                            for (const item in this.authorityData[i].children[j].children) {
                                this.authorityData[i].children[j].children[item].disabled = true
                            }
                        }
                    } else {
                        this.authorityData[i].disabled = false
                    }
                }
            } else {
                this.authorityData = this.deepClone(this.authorityDataBack)
            }
        },
        checkChange (data) {
            this.checkedTree = data
        },
        getcheckedTree (data) {
            for (const i in data) {
                if (data[i].children && data[i].children.length > 0) {
                    this.getcheckedTree(data[i].children)
                } else if (Number(data[i].index) === 3) {
                    this.checkedAll.push(data[i].data)
                }
            }
        },
        // 提交
        submit () {
            const params = {
                policyName: this.formData.policyName,
                displayName: this.formData.displayName,
                description: this.formData.description
            }
            this.$refs.form.validate((v) => {
                if (v) {
                    this.loading = true
                    if (this.isCreate) {
                        let data = []
                        // 创建
                        if (this.checkedTree.length > 0 && this.checkedTree[0].title === '全部') {
                            // data = [{ assertionSid: 1, serviceCode: 'all', serviceName: '全部' }]
                            this.getcheckedTree(this.authorityData)
                            data = this.checkedAll
                        } else {
                            for (let i = 0; i < this.checkedTree.length; i++) {
                                if (Number(this.checkedTree[i].index) === 3) {
                                    data.push(this.checkedTree[i].data)
                                }
                            }
                        }
                        params.assertions = data
                        params.policyType = 'custom'
                        this.axios.post(this.urlFormat(API.ACCESS_POLICES, false), params).then(res => {
                            this.loading = false
                            this.$emit('refresh')
                            this.cancel()
                        }).catch(e => {
                            this.loading = false
                        })
                    } else {
                        // 编辑
                        params.policySid = this.formData.policySid
                        this.axios.put(this.urlFormat(API.ACCESS_POLICES, false), params).then(res => {
                            this.loading = false
                            this.$emit('refresh')
                            this.cancel()
                        }).catch(e => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        cancel () {
            this.$refs.form.resetFields()
            this.formData = {
                policySid: '',
                policyName: '',
                displayName: '',
                description: ''
            }
            this.checkedAll = []
            this.modal = false
        }
    }
}
</script>
<style lang="less">
.authority .ivu-tree ul li {
    margin: 0;
}
.authority {
    min-height: 50px;
    overflow: hidden;
    overflow-y: auto;
    max-height: 230px;
    border: 1px solid #eee;
    width: 80%;
    padding: 10px;
}
</style>
